"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComplianceAnalysis = exports.getComplianceReport = void 0;
const shared_1 = require("@getgreenline/shared");
const BaseComplianceModels_1 = require("../models/BaseComplianceModels");
const getComplianceReport = (companyId, province, filter) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`/api/v1/company/${companyId}/reports/compliance`, {
        params: filter,
    });
    return response.data;
});
exports.getComplianceReport = getComplianceReport;
const getComplianceAnalysis = (companyId, locationIds, year, month, timeFrame = BaseComplianceModels_1.ComplianceTimeFrame.MONTHLY) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`/api/v1/company/${companyId}/reports/compliance/analysis`, {
        params: {
            locationIds,
            year,
            month,
            timeFrame,
        },
    });
    const complianceAnalaysis = response.data.complianceAnalysis;
    return complianceAnalaysis;
});
exports.getComplianceAnalysis = getComplianceAnalysis;
//# sourceMappingURL=BaseComplianceApi.js.map